import React, { useState, useEffect } from 'react';
import './Platform.css';
import { CDN_URLS } from '../config/cdn';
import SpriteAnimatedLogo from '../ui/SpriteAnimatedLogo.js';
import { DEFAULT_ANIM_FRAME_RATE } from '../config/const.js';
import { SPRITES } from '../ui/SpriteAnimatedLogo.js';

const Platform = () => {
  // const [activeTab, setActiveTab] = useState('Product');
  const [currentSlide, setCurrentSlide] = useState(0);

  // const useCases = [
  //   'Product',
  //   'Engineering', 
  //   'Design',
  //   'IT',
  //   'Marketing',
  //   'Startups'
  // ];

  // Showcase images array
  const showcaseImages = [
    { src: CDN_URLS.showcase.showcase1, alt: 'memU platform interface 1' },
    { src: CDN_URLS.showcase.showcase2, alt: 'memU platform interface 2' },
    { src: CDN_URLS.showcase.showcase3, alt: 'memU platform interface 3' },
    { src: CDN_URLS.showcase.showcase4, alt: 'memU platform interface 4' },
    { src: CDN_URLS.showcase.showcase5, alt: 'memU platform interface 5' }
  ];

  // Auto-slide effect
  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % showcaseImages.length);
    }, 6000); // Change slide every 6 seconds

    return () => clearInterval(slideInterval);
  }, [showcaseImages.length]);

  return (
    <section className="platform">
      <div className="platform-header">
        <h1 className="platform-main-title">
          Memory that works everywhere
        </h1>
        <p className="platform-subtitle">
          Simple, fast, and reliable memory infrastructure for AI applications.
        </p>
      </div>

      <div className="platform-showcase">
        <div className="showcase-container">
          <div className="carousel-wrapper">
            <div className="carousel-container">
              <div
                className="carousel-track"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {showcaseImages.map((image, index) => (
                  <div key={index} className="carousel-slide">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="platform-demo-image"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="platform-anim1">
            <SpriteAnimatedLogo
              width={80}
              height={80}
              frameRate={DEFAULT_ANIM_FRAME_RATE}
              autoPlay={true}
              filename={SPRITES.ANIM_PROBE_TOP} />
          </div>

        </div>
        {/* Progress Indicators */}
        <div className="carousel-indicators">
          <div className="progress-track">
            <div
              className="progress-fill"
              style={{ width: `${((currentSlide + 1) / showcaseImages.length) * 100}%` }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Platform;